<template>
  <v-container class="px-0 py-0">
    <v-form ref="recursosPorCompetenciaFilterForm">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6" md="3">
          <CompetenciaSelect v-model="competencia" />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <PrestadorAutocomplete v-model="prestadorId" />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <OperadoraAutocomplete v-model="operadoraId" :prestadorId="prestadorId" />
        </v-col>
        <v-col cols="12" sm="6" md="3" class="pt-0">
          <v-btn
            @click="getRescursosGlosaPorCompetencia()"
            color="primary"
            class="px-1 mr-3"
            small 
            depressed
          >
            Filtrar
          </v-btn> 
          <v-btn
            @click="clearFilters()"
            color="primary"
            class="px-1"
            outlined
            small 
            depressed
          >
            Limpar Filtro
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import moment from 'moment'
import CompetenciaSelect from './CompetenciaSelect.vue'
import OperadoraAutocomplete from './OperadoraAutocomplete.vue'
import PrestadorAutocomplete from './PrestadorAutocomplete.vue'
import { mapState } from "vuex";

export default {
  components: {
    CompetenciaSelect,
    OperadoraAutocomplete,
    PrestadorAutocomplete
  },
  props: {
    getRecursosGlosa: Function
  },
  data() {
    return {
      competencia: null,
      prestadorId: null,
      operadoraId: null
    }
  },
  computed: {
    ...mapState({
        formRules: state => state.formRules
    }),  
    payload: function () {
      return {
        prestador_id: this.prestadorId ? [this.prestadorId] : [],
        operadora_ans_id: this.operadoraId ? [this.operadoraId] : [],
        data_entre: moment(this.competencia).format('YYYY-MM-DD'),
        data_ate: moment(this.competencia).endOf('month').format('YYYY-MM-DD')
      }
    }
  },  
  methods: {
    clearFilters: function () {
      this.$refs.recursosPorCompetenciaFilterForm.reset()
      // this.prestadorId = null
      // this.operadoraId = null
      this.$refs.recursosPorCompetenciaFilterForm.resetValidation()
    },
    getRescursosGlosaPorCompetencia: function () {
      if(this.$refs.recursosPorCompetenciaFilterForm.validate()){
      this.$nextTick(() => this.getRecursosGlosa(this.payload))
      }
    },
    
  }
}
</script>
